<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{'base.cooking_info' | translate}}
    v-card-content
      v-text-field(
        :focus="true"
        :label="'base.name'| translate"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        @input="clearError('name')"
        v-model="payload.name")
      v-select(
        label-active
        :label="'base.recipe'| translate"
        item-name="ingredient_name"
        item-value="id"
        :options="recipesList"
        :hint="errorMessage('animalfeed_recipe')"
        :invalid="!!errorMessage('animalfeed_recipe')"
        @input="clearError('animalfeed_recipe')"
        v-model="payload.animalfeed_recipe")
      v-date-field(
        :label="'base.date'| translate"
        :min-date="minDate"
        v-model="payload.planned_on")
      v-switch.mb-3(
        :label="'base.planing_on_nex_day'| translate"
        v-model="payload.auto_planning")
      v-text-field.mb-3(
        :label="'base.mixing_mass'| translate"
        v-model="payload.plan_weight")
      ui-number-input(
        :label="'base.mix_time'| translate"
        :postfix="'base.min'| translate"
        v-model="payload.mix_time")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="onCreate")
        | {{ 'base.add_to_schedule' | translate }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
import UiNumberInput from '@/components/ui/ui-number-input/UiNumberInput'
import { getDateForDatePicker } from '@/util'
export default {
  name: 'CreatePlanningModal',

  components: {
    UiNumberInput
  },

  mounted () {
    this.payload.planned_on = this.filters.planned_on
    const params = {
      farm: this.$route.params.farm_id
    }
    this.loadRecipesList(params)
  },

  data: () => ({
    payload: {
      name: null,
      planned_on: null,
      animalfeed_recipe: null,
      mix_time: 10,
      plan_weight: null,
      auto_planning: false
    },
    errors: {
      name: null,
      animalfeed_recipe: null
    },
    loading: false
  }),
  mixins: [formErrorsMixin],
  methods: {
    ...mapActions('recipes', [
      'loadRecipesList'
    ]),

    ...mapActions('animalfeed', [
      'createSchedule'
    ]),

    async onCreate () {
      const payload = {
        farm: +this.$route.params.farm_id,
        schedule_animalfeed_recipe: {
          animalfeed_recipe: this.payload.animalfeed_recipe
        },
        ordering: 0,
        name: this.payload.name,
        plan_weight: +this.payload.plan_weight,
        mix_time: +this.payload.mix_time,
        mixer_balance: 0,
        is_active: true,
        auto_planning: this.payload.auto_planning,
        planned_on: this.payload.planned_on + 'T15:00:00.817Z'
      }
      if (!this.checkValidData()) return
      this.loading = true
      await this.createSchedule(payload)
      this.$emit('close')

      this.loading = false
    },
    checkValidData () {
      let valid = true
      this.errors.name = null
      this.errors.animalfeed_recipe = null

      if (!this.payload.name) {
        this.errors.name = this.errors.name = ['3']
        valid = false
      } else if (this.payload.name.length > 100) {
        this.errors.name = this.errors.name = ['6', 100]
        valid = false
      }
      if (!this.payload.animalfeed_recipe) {
        valid = false
        this.errors.animalfeed_recipe = this.errors.animalfeed_recipe = ['3']
      }

      return valid
    }
  },

  computed: {
    ...mapGetters('recipes', [
      'recipesList'
    ]),

    ...mapGetters('animalfeed', [
      'filters'
    ]),
    timezone () {
      return this.$store.getters['account/timezone']
    },
    minDate () {
      return getDateForDatePicker(this.timezone)
    }
  }
}
</script>
